<template>
  <modal v-if="show" :close="close">
    <h3 slot="header">{{ $t('project.remove.header') }}</h3>
    <div slot="body">
      <div class="modal-body">
        <h4 v-show="!success">{{ $t('project.remove.areYouSure') }}</h4>
        <alert :success="success" class="mt-10 mb-0"></alert>
      </div>
    </div>
    <div slot="footer" style="display: inline">
      <button type="button" @click="removeProject" class="btn btn-primary">{{ $t('remove') }}</button>
    </div>
  </modal>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
// Components
import Modal from '@/components/Modal';
import Alert from '@/components/Alert';

export default {
  props: ['project', 'show', 'close'],
  components: { Modal, Alert },
  data() {
    return {
      success: '',
    };
  },
  methods: {
    removeProject() {
      const vm = this;
      function succ() {
        vm.success = vm.$t('project.remove.successAlert');
        setTimeout(() => { window.history.back(); }, 3000);
      }
      projectsApi.destroy(this.project.id, succ);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Remove.vue?03120149